(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Calendar.ListView",
                {
                    url: "/List",
                    component: "listView",
                    resolve: {
                    },
                    data: {
                        pageTitle: "List View"
                    }
                });
        }
    ]);

    app.component("listView",
        {
            templateUrl: "/App/Calendar/ListView/listview-template.html",
            controller: listViewController,
            bindings: {
                allAppointments: "<",
                allScheduledTasks: "<",
                allMarketingTrackerEvents: "<",
                eventFilter: "<",
                ui: "=",
                onCalendarDateChange: "&"
            }
        });

    listViewController.$inject = ["_", "moment", "modalService"];
    function listViewController(_, moment, modalService) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    isCalendarView: false,
                    showCompletedTasks: "!",
                    taskOrderBy: "-",
                    appointmentOrderBy: "-",
                    marketingTrackerEventsOrderBy: "-"
                },
                modalService: modalService,
                appointmentsLimit: 8,
                tasksLimit: 8,
                marketingEventsLimit: 8,
                filterByUser: filterByUser,
                filterAppointments: filterAppointments,
                filterMarketingTrackerEvents: filterMarketingTrackerEvents
            });

        function filterByUser() {

            $ctrl.filteredAppointments = _
                .chain($ctrl.allAppointments)
                .map("data")
                .flatten()
                .filter(event => {
                    const eventStartDate = moment(event.StartDate);
                    const eventEndDate = moment(event.EndDate);
                    const selectedMonth = moment([$ctrl.ui.year, $ctrl.ui.month]);
                    return eventStartDate.isBefore(moment(selectedMonth).endOf('month')) && eventEndDate.isAfter(moment(selectedMonth).startOf('month'));
                })
                .filter(event => {
                    return _.intersection(event.AssignedUserIds, _.map($ctrl.ui.selectedUsers, "Id")).length > 0 ? true : false;
                })
                .map(event => {
                    const evtCopy = event;
                    evtCopy.multiDay = !moment(event.StartDate).isSame(event.EndDate, 'date');  // See if event spans multiple days
                    return evtCopy;
                })
                .value();

            $ctrl.filteredScheduledTasks = _
                .chain($ctrl.allScheduledTasks)
                .map("data")
                .flatten()
                .filter(event => {
                    var date = moment(event.DueDate);
                    return date.year() === $ctrl.ui.year && date.month() === $ctrl.ui.month;
                })
                .filter(event => {
                    return _.includes(_.map($ctrl.ui.selectedUsers, "Id"), event.AssignedUserId);
                })
                .map(event => {
                    //TODO: move isAllDay & endTime to backend model
                    const dueDate = moment(event.DueDate).format();
                    const allDay = moment(event.DueDate).hour(0).minute(0).second(0).format();
                    event.isAllDay = dueDate === allDay ? true : false;
                    return event;
                })
                .value();

            $ctrl.filteredMarketingTrackerEvents = _
                .chain($ctrl.allMarketingTrackerEvents)
                .map("data")
                .flatten()
                .filter(event => {
                    return _.includes(_.map($ctrl.ui.selectedUsers, "FigAuthId"), event.FigAuthId) || event.EventType.Name === "FIG Event";
                })
                .filter(event => {
                    var date = moment(event.EventDate);
                    return date.year() === $ctrl.ui.year && date.month() === $ctrl.ui.month;
                }).value();
        }

        function filterAppointments(row) {
            if ($ctrl.ui.showFutureAppointments)
                return row.StartDate > new Date();
            return true;
        }

        function filterMarketingTrackerEvents(row) {
            if ($ctrl.ui.showFutureMarketingTrackerEvents)
                return row.EventDate > new Date();
            return true;
        }

        $ctrl.$onChanges = function () {
            filterByUser();
        };

        $ctrl.$onInit = () => {
            $ctrl.ui.isCalendarView = false;
            $ctrl.taskList = {};
            filterByUser();
        }
    }

})(window.app, window.angular); //jshint ignore:line